import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getRecordatoriosTaller, updateRecordatorioTaller } from '../services/api';

const fecha = (d) => d ? new Date(d).toLocaleDateString('es-CO') : '—';

export default function RecordatoriosTaller() {
  const nav = useNavigate();
  const [lista, setLista] = useState([]);

  const load = () => getRecordatoriosTaller({ estado:'pendiente' }).then(r => setLista(r.data));
  useEffect(() => { load(); }, []);

  const marcar = (id, estado) => updateRecordatorioTaller(id, estado).then(load);

  const vencidos = lista.filter(r => r.vencido);
  const proximos = lista.filter(r => !r.vencido);

  const Fila = (r) => (
    <div key={r.id} style={s.row}>
      <span style={s.placa}>{r.placa}</span>
      <div style={{ flex:1 }}>
        <div style={{ color:'#e2e8f0', fontSize:13, fontWeight:600 }}>{r.tipo}</div>
        <div style={{ color:'#64748b', fontSize:12 }}>
          {[r.marca, r.linea].filter(Boolean).join(' ')}
          {r.proximo_km != null ? ` · a los ${Number(r.proximo_km).toLocaleString('es-CO')} km (actual ${Number(r.km_actual||0).toLocaleString('es-CO')})` : ''}
          {r.proxima_fecha ? ` · ${fecha(r.proxima_fecha)}` : ''}
        </div>
      </div>
      {r.vencido && <span style={s.badgeVenc}>Vencido</span>}
      <button style={s.btnOk} onClick={() => marcar(r.id, 'hecho')}>Hecho</button>
      <button style={s.btnX} onClick={() => marcar(r.id, 'descartado')}>Descartar</button>
    </div>
  );

  return (
    <div>
      <div style={s.pageHeader}>
        <div><h1 style={s.h1}>Recordatorios de mantenimiento</h1><p style={s.sub}>Próximos servicios por km o por fecha</p></div>
      </div>

      {lista.length === 0 && <div style={s.card}><div style={s.empty}>No hay recordatorios pendientes</div></div>}

      {vencidos.length > 0 && (
        <div style={{ ...s.card, marginBottom:14 }}>
          <div style={s.cardHead}><h3 style={{ ...s.cardTitle, color:'#fca5a5' }}>Vencidos ({vencidos.length})</h3></div>
          {vencidos.map(Fila)}
        </div>
      )}
      {proximos.length > 0 && (
        <div style={s.card}>
          <div style={s.cardHead}><h3 style={s.cardTitle}>Próximos ({proximos.length})</h3></div>
          {proximos.map(Fila)}
        </div>
      )}
    </div>
  );
}

const s = {
  pageHeader: { display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:10 },
  h1:         { color:'#f1f5f9', fontSize:24, fontWeight:700, margin:'0 0 4px' },
  sub:        { color:'#64748b', fontSize:14, margin:0 },
  card:       { background:'#1e293b', borderRadius:12, padding:16 },
  cardHead:   { marginBottom:8 },
  cardTitle:  { color:'#f1f5f9', fontSize:15, fontWeight:600, margin:0 },
  empty:      { color:'#475569', textAlign:'center', padding:'20px 0', fontSize:13 },
  row:        { display:'flex', alignItems:'center', gap:12, background:'#0f172a', border:'1px solid #243044', borderRadius:8, padding:'8px 12px', marginBottom:6 },
  placa:      { background:'#1e293b', border:'1px solid #334155', color:'#f1f5f9', borderRadius:4, padding:'2px 8px', fontSize:12, fontWeight:700, letterSpacing:0.5 },
  badgeVenc:  { background:'#450a0a', color:'#fca5a5', borderRadius:12, padding:'2px 10px', fontSize:11, fontWeight:600 },
  btnOk:      { background:'#14532d', color:'#86efac', border:'none', borderRadius:6, padding:'5px 12px', fontSize:12, cursor:'pointer' },
  btnX:       { background:'transparent', color:'#64748b', border:'1px solid #334155', borderRadius:6, padding:'5px 10px', fontSize:12, cursor:'pointer' },
};
